module.exports = __webpack_public_path__ + "88a40b71abf3fcc222e732efce178f67.woff2";